const t = {
  name: "NavigationExpand",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.5859 12L11.5859 16L13.0001 17.4142L18.4143 12L13.0001 6.58576L11.5859 7.99997L15.5859 12Z" fill="currentColor"/>
<path d="M19 22C20.6523 22 22 20.6523 22 19V5C22 3.34772 20.6523 2 19 2H5C3.34772 2 2 3.34772 2 5V19C2 20.6523 3.34772 22 5 22H19ZM5 4H8V20H5C4.45228 20 4 19.5477 4 19V5C4 4.45228 4.45228 4 5 4ZM19 4C19.5477 4 20 4.45228 20 5V19C20 19.5477 19.5477 20 19 20H10V4H19Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as NavigationExpand
};
